import * as PIXI from "pixi.js";
import Game from "../Game";
import { EventBus } from "../manager/eventBus";

export default class BaseController extends PIXI.Container {
  Game: Game;
  header: string;
  eventName: string;
  steps: number;
  currStep: number;
  bColor: number;
  startValue: number;
  button: PIXI.Sprite;
  isDragging: boolean;
  startDragX: number;
  constructor(header: string, eventName: string, steps: number, initialStep: number, startValue: number, bColor: number) {
    super();
    this.Game = Game.getInstance();
    this.header = header;
    this.eventName = eventName;
    this.steps = steps;
    this.currStep = initialStep;
    this.startValue = startValue;
    this.bColor = bColor;
    this.addBg();
    this.addSlider();
    this.addButton();
    this.addheader();

    this.interactive = true;
    this.on("mousemove", this.handleMousemove);

    this.Game.topContainer.addChild(this);
  }

  handleMousemove(e: PIXI.FederatedPointerEvent) {
    const minValue = 20;
    const maxValue = 240;
    const stepSize = (maxValue - minValue) / this.steps;
    if (this.isDragging) {
      const delta = this.button.x = e.globalX - this.x;
      const newX = Math.min(Math.max(minValue, delta), maxValue);
      this.button.x = newX;
      const currStep = Math.floor((newX - minValue) / stepSize) + this.startValue;
      if (currStep != this.currStep) {
        this.currStep = currStep;
        EventBus.emit(this.eventName, this.currStep); // Olayı yayınla
      }
    }
  }
  addBg() {
    const bg = new PIXI.Graphics()
      .roundRect(0, 0, 260, 120, 3)
      .fill(0x23d4ff)
      .stroke(0x000000)
    this.addChild(bg);
  }
  addSlider() {
    const line = new PIXI.Graphics()
      .roundRect(20, 80, 220, 4, 2)
      .fill(0x777777)
    this.addChild(line);
  }
  handleButton() {

  }
  addButton() {
    const button = new PIXI.Sprite(PIXI.Texture.WHITE);
    button.width = 20;
    button.height = 30;
    button.anchor.set(.5, .5);
    button.x = 20;
    button.y = 80;
    button.tint = this.bColor;
    button.interactive = true;
    button
      .on("mousedown", e => {
        this.isDragging = true;
        this.startDragX = e.clientX;
      })
      .on("mouseup", () => this.isDragging = false)
      .on("pointerupoutside", () => this.isDragging = false);

    this.button = button;
    this.addChild(button);
  }
  addheader() {
    const header = new PIXI.Text({
      text: this.header
    })
    header.x = 130;
    header.y = 20;
    header.anchor.set(.5, 0)
    this.addChild(header);
  }
}